import { useRef } from "react";
import {
  CarouselContainer,
  ScrollWrapper,
  WallpaperCard,
} from "./WallpaperCarouselStyles";

interface WallpaperCarouselProps {
  wallpapers: string[];
  selectedUrl?: string;
  onSelect: (url: string) => void;
}

const WallpaperCarousel = ({
  wallpapers,
  selectedUrl,
  onSelect,
}: WallpaperCarouselProps) => {
  const scrollRef = useRef<HTMLDivElement>(null);

  const handleCardClick = (index: number) => {
    const url = wallpapers[index];
    onSelect(url);

    const container = scrollRef.current;
    const card = container?.children[index] as HTMLElement;
    if (container && card) {
      container.scrollTo({
        left:
          card.offsetLeft - container.offsetWidth / 2 + card.offsetWidth / 2,
        behavior: "smooth",
      });
    }
  };

  return (
    <CarouselContainer>
      <ScrollWrapper ref={scrollRef}>
        {wallpapers.map((url, index) => {
          const isActive = selectedUrl === url;
          return (
            <WallpaperCard
              key={url}
              $active={isActive}
              onClick={() => handleCardClick(index)}
            >
              <img src={url} alt={`Wallpaper ${index + 1}`} />
            </WallpaperCard>
          );
        })}
      </ScrollWrapper>
    </CarouselContainer>
  );
};

export default WallpaperCarousel;
